import React from 'react';
import { LeaderboardPlayerName } from './PrivateLeaderboardPlayerLabel';

export interface LeaderboardTop3Player {
  avatarText: string;
  name: string;
  value?: string;
  isCurrentUser?: boolean;
}

interface LeaderboardTop3Props {
  first?: LeaderboardTop3Player;
  second?: LeaderboardTop3Player;
  third?: LeaderboardTop3Player;
}

const Top3Item: React.FC<{
  player?: LeaderboardTop3Player;
  rank: 1 | 2 | 3;
}> = ({ player, rank }) => {
  const label = rank === 1 ? '1ST' : rank === 2 ? '2ND' : '3RD';
  const tierClass = rank === 1 ? 'gold' : rank === 2 ? 'silver' : 'bronze';

  return (
    <div className={`leaderboard-top3__col leaderboard-top3__col--${tierClass}`}>
      <div className="leaderboard-top3__position">{label}</div>
      <div className={`leaderboard-top3__item leaderboard-top3__item--${tierClass}`}>
        <div className="leaderboard-top3__avatar-wrap">
          {rank === 1 && (
            <img
              className="leaderboard-top3__crown"
              src="/assets/images/top-1-rank.png"
              alt="Crown"
              aria-hidden="true"
            />
          )}
          <div className={`leaderboard-top3__avatar leaderboard-top3__avatar--${tierClass}`}>
            {player?.avatarText ?? ''}
          </div>
        </div>
       
        {player?.value && (
          <div className={`leaderboard-top3__value leaderboard-top3__value--${tierClass}`}>
            {player.value}
          </div>
        )}
        <div className="leaderboard-top3__name">
          {player?.name ? <LeaderboardPlayerName name={player.name} /> : '—'}
        </div>
        {/* todo to implement badges  */}
        {/* <div className="leaderboard-top3__badges">
          <img src="/assets/images/badge-jackpot.png"  alt="Jackpot"  className="leaderboard-top3__badge-icon" />
          <img src="/assets/images/badge-money.png"    alt="Money"    className="leaderboard-top3__badge-icon" />
          <img src="/assets/images/badge-spin.png"     alt="Spin"     className="leaderboard-top3__badge-icon" />
          <img src="/assets/images/badge-win-spin.png" alt="Win Spin" className="leaderboard-top3__badge-icon" />
        </div> */}
      </div>
    </div>
  );
};

const LeaderboardTop3: React.FC<LeaderboardTop3Props> = ({ first, second, third }) => {
  return (
    <div className="leaderboard-top3">
      {second && <Top3Item player={second} rank={2} />}
      {first && <Top3Item player={first} rank={1} /> }
      {third && <Top3Item player={third} rank={3} /> }
    </div>
  );
};

export default LeaderboardTop3;
